module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hyra-ut-rum"
    }
  }, [_c('h1', [_vm._v("Hyra ut rum")]), _vm._v(" "), _c('p', [_vm._v("När man hyr ut rum får man inte sätta hyran hur högt man vill.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b8a3a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rum.vue
// module id = 21
// module chunks = 0